import { ContextualMenuPluginKey } from './ContextualMenuPlugin.js';

class ContextualMenuMeta {
  constructor(spec, from, to, summoned = false, mobile = false) {
    this.spec = spec;
    this.from = from;
    this.to = to;
    this.summoned = summoned;
    this.mobile = mobile;
  }
  static isContextualMenuMeta(meta) {
    return meta instanceof ContextualMenuMeta;
  }
  static reset(view) {
    const tr = view.state.tr.setMeta(ContextualMenuPluginKey, new ContextualMenuMeta(null, 0, 0));
    view.dispatch(tr);
  }
}

export { ContextualMenuMeta };
//# sourceMappingURL=ContextualMenuMeta.js.map
